import dynaForms from '@elab/core/utils/dynaForms';

import createSagaFor from './saga';

export const storeName = 'loyalty-options-form';
export const reducers = dynaForms.createReducer(storeName);
export const actions = dynaForms.getActions(storeName);
export const selectors = dynaForms.getSelectors(storeName);
export const types = dynaForms.getTypes(storeName);
export const sagaFactory = createSagaFor(storeName);

export default reducers;
